import * as React from 'react';
import { times } from 'lodash';
import DataTable, { IDataTableColumn } from 'react-data-table-component';
import { ILastProcessedProps } from './lastProcessed.types';
import { IETLLog, IRekLog } from 'src/share/types/serviceStatus';
import { handleTableLogSettings } from '../utils/tableLogs';

export interface IETLStatusTableProps extends ILastProcessedProps {
    logs: IETLLog[] | IRekLog[];
    loading: boolean;
    onSizeChanged: (size: number, page: number) => void;
    onPageChanged: (page: number) => void;
    onSort: (column: IDataTableColumn, sortDirection: string) => void;
    total: number;
}

const StatusServiceTableLogs: React.SFC<IETLStatusTableProps> = (props) => {
    const { logs, loading, onSort, total, onSizeChanged, onPageChanged, mode } = props;
    const loadingArray = React.useRef(times(10, Object));
    const settings = handleTableLogSettings(mode, logs, loading);
    return (
        <DataTable
            columns={settings.colums}
            data={loading ? loadingArray.current : settings.format}
            highlightOnHover={true}
            fixedHeader={true}
            className="application-ServiceStatusLogs__table"
            responsive={false}
            noHeader={true}
            subHeader={false}
            pagination={true}
            paginationServer={true}
            paginationTotalRows={total}
            sortServer={true}
            onSort={onSort}
            onChangeRowsPerPage={onSizeChanged}
            onChangePage={onPageChanged}
        />
    );
}

export default StatusServiceTableLogs;


// WEBPACK FOOTER //
// ./src/modules/UserSettings/ServicesStatus/component/ServiceStatusLogsTable.tsx